export default "__VITE_ASSET__sNTduTcI__"